module.exports = __webpack_public_path__ + "static/khaled-mahiout-c3f392283fbc85c255f856ab8d0f8622.jpg";